import { render, staticRenderFns } from "./section-widget.vue?vue&type=template&id=c144ea64&scoped=true"
import script from "./section-widget.vue?vue&type=script&lang=js"
export * from "./section-widget.vue?vue&type=script&lang=js"
import style0 from "./section-widget.vue?vue&type=style&index=0&id=c144ea64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c144ea64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c144ea64')) {
      api.createRecord('c144ea64', component.options)
    } else {
      api.reload('c144ea64', component.options)
    }
    module.hot.accept("./section-widget.vue?vue&type=template&id=c144ea64&scoped=true", function () {
      api.rerender('c144ea64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/section/section-widget.vue"
export default component.exports